import { Component } from "react";

class SkeletonYoutube extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: "",
      floatMenu: false,
      width: 0,
      height: 0,
      flagPotraitPhone: false,
    };
  }

  componentDidMount = async () => {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
    // console.log('innerWidth = ' + window.innerWidth)
    // console.log('innerHeight = ' + window.innerHeight)
    if (window.innerWidth < 500 && window.innerHeight > 650) {
      // console.log("disini")
      this.setState({ flagPotraitPhone: true });
    } else if (window.innerWidth > 700 && window.innerHeight > 500) {
      // console.log("disini 1")
      this.setState({ flagPotraitPhone: true });
    } else {
      // console.log("disini 2")
      this.setState({ flagPotraitPhone: false });
    }
    // console.log('innerWidth = ' + this.state.width)
    // console.log('innerHeight = ' + this.state.height)
  };

  render() {
    return (
      <div>
        <nav className="p-4 fixed flex w-full top-0 z-10 bg-orange shadow-md">
          <div className="text-lg text-white font-semibold items-center">
            Video
          </div>
        </nav>
        <div className="pt-[60px] mb-24">
          <div className="mb-2.5 shadow-md">
            <div className="relative w-full h-60 bg-gray-300 animate-pulse"></div>
            <div className="flex min-h-[80px] p-2.5 bg-white items-center">
              <div className="mr-3">
                <div className="w-11 h-11 overflow-hidden rounded-full bg-gray-300 animate-pulse"></div>
              </div>
              <div className="w-11/12 animate-pulse">
                <div className="mb-1 w-56 h-4 bg-gray-300 rounded-full"></div>
                <div className="mt-2 w-32 h-4 bg-gray-300 rounded-full"></div>
              </div>
            </div>
          </div>
          <div className="sm:block md:hidden">
            <div className="px-4">
              <div className="flex mb-2.5 p-2.5 bg-white border rounded-xl shadow-md">
                <div className="w-[90px] h-[90px] mr-3 bg-gray-300 rounded-xl animate-pulse"></div>
                <div className="w-8/12 animate-pulse">
                  <div className="w-52 h-4 mb-2 bg-gray-300 rounded-full"></div>
                  <div className="w-40 h-4 bg-gray-300 rounded-full"></div>
                </div>
              </div>
              <div className="flex mb-2.5 p-2.5 bg-white border rounded-xl shadow-md">
                <div className="w-[90px] h-[90px] mr-3 bg-gray-300 rounded-xl animate-pulse"></div>
                <div className="w-8/12 animate-pulse">
                  <div className="w-52 h-4 mb-2 bg-gray-300 rounded-full"></div>
                  <div className="w-40 h-4 bg-gray-300 rounded-full"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="hidden md:block">
            <div className="mt-4 mb-4 px-4 grid grid-cols-4 gap-4">
              <div className="rounded-xl shadow-md">
                <div className="h-[120px] overflow-hidden animate-pulse">
                  <div className="w-full h-[200px] bg-gray-300 rounded-xl"></div>
                </div>
                <div className="p-2 min-h-[116px]">
                  <div className="w-36 h-4 mb-2 bg-gray-300 rounded-full"></div>
                  <div className="w-24 h-4 bg-gray-300 rounded-full"></div>
                </div>
              </div>
              <div className="rounded-xl shadow-md">
                <div className="h-[120px] overflow-hidden animate-pulse">
                  <div className="w-full h-[200px] bg-gray-300 rounded-xl"></div>
                </div>
                <div className="p-2 min-h-[116px]">
                  <div className="w-36 h-4 mb-2 bg-gray-300 rounded-full"></div>
                  <div className="w-24 h-4 bg-gray-300 rounded-full"></div>
                </div>
              </div>
              <div className="rounded-xl shadow-md">
                <div className="h-[120px] overflow-hidden animate-pulse">
                  <div className="w-full h-[200px] bg-gray-300 rounded-xl"></div>
                </div>
                <div className="p-2 min-h-[116px]">
                  <div className="w-36 h-4 mb-2 bg-gray-300 rounded-full"></div>
                  <div className="w-24 h-4 bg-gray-300 rounded-full"></div>
                </div>
              </div>
              <div className="rounded-xl shadow-md">
                <div className="h-[120px] overflow-hidden animate-pulse">
                  <div className="w-full h-[200px] bg-gray-300 rounded-xl"></div>
                </div>
                <div className="p-2 min-h-[116px]">
                  <div className="w-36 h-4 mb-2 bg-gray-300 rounded-full"></div>
                  <div className="w-24 h-4 bg-gray-300 rounded-full"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SkeletonYoutube;
